import React from 'react';
import { Tooltip, TextFieldProps } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

import CustomTextField from './styles/CustomTextField';
import CustomTableCell from './styles/CustomTableCell';
import Wrapper from './styles/Wrapper';

type Props = {
  textFieldProps: TextFieldProps & { hasErrorIcon: boolean; fieldFuelAvailable: number };
};
function CellInput({ textFieldProps }: Props) {
  const { fieldFuelAvailable, hasErrorIcon } = textFieldProps;
  return (
    <CustomTableCell align="right" isError={hasErrorIcon}>
      <Wrapper>
        <CustomTextField {...textFieldProps} />
        {hasErrorIcon && (
          <Tooltip
            title={`Сумарный расход топлива превышает сумарный остаток топлива (Сумарный остаток: ${Number(fieldFuelAvailable).toFixed(2)} л.)`}
            arrow
          >
            <WarningIcon color="error" sx={{ width: 20 }} />
          </Tooltip>
        )}
      </Wrapper>
    </CustomTableCell>
  );
}

export default CellInput;
